import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Link } from "src/react/components/link";
import { color } from "src/styles/variables";
import OrderSummary from "./order-summary";
import ProductsSummary from "./products-summary";

function CheckoutReview({
  children,
  products = [],
  hasInternationalPostage,
  basketQuantity,
  editBasketLink,
  discount,
  couponAppliedMessage,
  couponMinimumSpendTooLow,
  total,
  orderValue,
  giftWrappingCost,
  deliveryCost,
}) {
  return (
    <ReviewWrapper data-selector="Checkout-Review">
      <ProductsSummary products={products} basketQuantity={basketQuantity} />
      {editBasketLink && (
        <CustomUpdateBasketLink
          data-selector="CheckoutReview-EditBasket"
          to={editBasketLink}
        >
          Edit basket
        </CustomUpdateBasketLink>
      )}
      <OrderSummary
        discount={discount}
        couponAppliedMessage={couponAppliedMessage}
        couponMinimumSpendTooLow={couponMinimumSpendTooLow}
        total={total}
        orderValue={orderValue}
        hasInternationalPostage={hasInternationalPostage}
        giftWrappingCost={giftWrappingCost}
        deliveryCost={deliveryCost}
      />
      {children}
    </ReviewWrapper>
  );
}

CheckoutReview.propTypes = {
  editBasketLink: PropTypes.string,
  children: PropTypes.any,
  products: PropTypes.array,
  basketQuantity: PropTypes.number,
  engraving: PropTypes.string,
  hasInternationalPostage: PropTypes.bool,
  discount: PropTypes.number,
  total: PropTypes.number,
  orderValue: PropTypes.number,
  couponAppliedMessage: PropTypes.string,
  giftWrappingCost: PropTypes.number,
  deliveryCost: PropTypes.number,
  couponMinimumSpendTooLow: PropTypes.bool,
};

export default CheckoutReview;

export const ReviewWrapper = styled.div`
  padding: 20px;
  background-color: white;
  border-radius: 10px;
  border: 1px solid ${color.shipGrey};
  margin-bottom: 20px;

  @media (min-width: 500px) {
    padding: 30px;
  }
`;

const CustomUpdateBasketLink = styled(Link)`
  font-size: 14px;
  margin-bottom: 10px;
`;
